export const USR = {
  loginForm: "login-form",
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginPasswordToggle: "login-password-toggle",
  loginSubmit: "login-submit",
  loginError: "login-error",
  loginDemoPanel: "login-demo-accounts",
  loginDemoBtn: "login-demo-btn",
  logoutBtn: "logout-btn",
  navUsers: "nav-users",
  page: "users-page",
  title: "users-title",
  newBtn: "new-user-btn",
  search: "user-search-input",
  table: "users-table",
  emptyState: "users-empty",
  loading: "users-loading",
  row: "user-row",
  editBtn: "user-edit-btn",
  deleteBtn: "user-delete-btn",
  form: "user-form",
  fUsername: "user-field-username",
  fEmail: "user-field-email",
  fFirst: "user-field-first",
  fLast: "user-field-last",
  fTitle: "user-field-title",
  fPhone: "user-field-phone",
  fPassword: "user-field-password",
  fPasswordToggle: "user-field-password-toggle",
  fActive: "user-field-active",
  fOrgWide: "user-field-orgwide",
  fOrg: "user-field-org",
  fDefaultLoc: "user-field-default-loc",
  roleOption: "user-role", // append -{code}
  locOption: "user-loc", // append -{id}
  saveBtn: "user-save-btn",
  cancelBtn: "user-cancel-btn",
  deleteDialog: "delete-user-dialog",
  confirmDelete: "confirm-delete-user-btn",
};
